import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';
import { WorkflowPanelComponent } from '@features/workflow-panel/workflow-panel.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { EventType, PermissionType, WorkflowStep } from '@shared/services/gql.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent, WorkflowPanelComponent],
  selector: 'aux-invoices-and-prepaids',
  templateUrl: './invoices-and-prepaids.component.html',
})
export class InvoicesAndPrepaidsComponent {
  private readonly authService = inject(AuthService);
  private readonly eventQuery = inject(EventQuery);
  private readonly launchDarklyService = inject(LaunchDarklyService);
  private readonly workflowQuery = inject(WorkflowQuery);

  iCloseMonthsProcessing = this.eventQuery.selectProcessingEvent(EventType.CLOSE_TRIAL_MONTH);
  indexFn = generateCustomIndexFn(`${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}`);
  isClosingPanelEnabled = this.launchDarklyService.$select(
    (flags) => flags.closing_checklist_toolbar
  );
  isQuarterCloseEnabled = this.workflowQuery.isWorkflowAvailable;
  tabs: TabGroupConfig[] = [
    {
      label: 'Invoices',
      route: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_invoices)),
    },
    {
      label: 'Prepaids',
      route: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.prepaids)),
    },
  ];
  userHasLockPrepaidPermission = this.authService.$isAuthorized({
    permissions: [PermissionType.PERMISSION_CHECKLIST_INVOICES],
    sysAdminsOnly: false,
  });
  readonly workflowName = WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_INVOICES;
}
